namespace RioERP.Orders {
    export interface OrderShippingForm {
        OrderId: Serenity.LookupEditor;
        ShippingProviderId: Serenity.LookupEditor;
        EStatus: Serenity.EnumEditor;
        TrackingId: Serenity.StringEditor;
        TrackingUrl: Serenity.StringEditor;
        ShippingCost: Serenity.IntegerEditor;
        ShippingDate: Serenity.DateEditor;
        OrdershippingBooks: OrdershippingBooksEditor;
        OrdershippingPendrives: OrdershippingPendrivesEditor;
    }

    export class OrderShippingForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.OrderShipping';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderShippingForm.init)  {
                OrderShippingForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.EnumEditor;
                var w2 = s.StringEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.DateEditor;
                var w5 = OrdershippingBooksEditor;
                var w6 = OrdershippingPendrivesEditor;

                Q.initFormType(OrderShippingForm, [
                    'OrderId', w0,
                    'ShippingProviderId', w0,
                    'EStatus', w1,
                    'TrackingId', w2,
                    'TrackingUrl', w2,
                    'ShippingCost', w3,
                    'ShippingDate', w4,
                    'OrdershippingBooks', w5,
                    'OrdershippingPendrives', w6
                ]);
            }
        }
    }
}
